import { StyleSheet, Platform } from "react-native";


const styles: any = StyleSheet.create({
	addPerson: {
		//color: '#438eb9',
		alignSelf: "center",
		//marginLeft: 20
	  },
	  labelIcon: {
		  color:'#2f6483',
		  alignSelf: "center",
		  marginRight: 20
	  },
	  footer: {
			backgroundColor: "#F8F8F8"
		},
	  modalContainer: {
		flex: 1,
		justifyContent: 'center',
		backgroundColor: 'grey',
	  },
	  innerContainer: {
		alignItems: 'center',
	  },
	  modalStyle: {
		borderRadius: 10,
		width:'90%', 
		height:'95%'
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	}
});
export default styles;